import { graphql, useStaticQuery } from 'gatsby';
import {
    KontentMedia,
    KontentRadioMultiChoice,
    KontentStringValue,
} from '../../../../types/KontentProps';

export interface Publication {
    id?: string;
    preferred_language?: string;
    elements: {
        content_type: KontentRadioMultiChoice<string>;
        research_type?: KontentRadioMultiChoice<string>;
        image: KontentMedia;
        publication_date: KontentStringValue;
        short_description: KontentStringValue;
        source: KontentStringValue;
        title: KontentStringValue;
        url_location: KontentStringValue;
        publication_logo: KontentMedia;
        blog_topic: KontentRadioMultiChoice<string>;
        wellness_type: KontentRadioMultiChoice<string>;
        country: KontentRadioMultiChoice<string>;
        document: {
            value: {
                elements: {
                    document: {
                        value: { url: string }[];
                    };
                };
            }[];
        };
    };
}

interface PublicationQuery {
    allKontentItemContentItemPublication: {
        nodes: Publication[];
    };
}

export const usePublications = (): Publication[] => {
    const publications: PublicationQuery = useStaticQuery(graphql`
        {
            allKontentItemContentItemPublication(
                sort: {
                    elements: { publication_date_for_sort: { value: DESC } }
                }
                filter: { system: { workflow_step: { ne: "archived" } } }
            ) {
                nodes {
                    ...kontentPublication
                }
            }
        }
    `);

    return publications.allKontentItemContentItemPublication.nodes;
};
